// Module
var code = "<supplier-compliance-documents\n  supplier-id=\"vm.supplier.id\"\n  documents-folder-id=\"vm.supplier.documentsFolderId\"\n></supplier-compliance-documents>\n";
// Exports
module.exports = code;